import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Box, MenuItem, Chip } from "@material-ui/core";
import { Button, IconButton, Modal, InputBase, Paper, TextField, Select, FormControl, InputLabel, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { FOOD_ITEMS, ORDERS } from "src/api/axios";
import { ORDER } from 'src/routes/paths'
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import BinIcon from "src/svgComponents/BinIcon";
import CloseIcon from '@mui/icons-material/Close';
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useTheme } from '@mui/material/styles';
import { useMutation } from "react-query";
import FormHelperText from "@mui/material/FormHelperText";
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import useStore from 'src/contexts/AuthProvider'
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from "moment";
import { useNavigate } from "react-router";
const _ = require('lodash');

const Order = () => {
   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('asc');
   const [orderBy, setOrderBy] = useState('name');
   const axiosPrivate = useAxiosPrivate();
   const [openModal, setOpenModal] = useState(false);
   const [profilePic, setProfilePic] = useState("");
   const [imageName, setImageName] = useState();
   const [showImage, setShowImage] = useState();
   const [modelTitle, setmodelTitle] = useState("");
   const [filterName, setFilterName] = useState('');
   const [food_category_id, setFoodCategoryId] = useState('');
   const [food_menu_id, setFoodMenuId] = useState('');
   const [disable, setDisable] = useState(false);
   const [Id, setId] = useState("");
   const { enqueueSnackbar } = useSnackbar();
   const [deleteId, setdeleteId] = useState("");
   const [open, setOpen] = useState(false);
   const theme = useTheme();
   const [loding, setLoding] = useState(true);
   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
   const permissionsData = useStore(state => state.permissions);
   const navigate = useNavigate();

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'user_name', label: 'User Name', alignRight: false },
      { id: 'email', label: 'Email', alignRight: false },
      { id: 'order_number', label: 'Order Number', alignRight: false },
      { id: 'created', label: 'Created Date', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   async function getOrder(page, filterName) {
      const response = await axiosPrivate.get(ORDERS.getOrder, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { data: orderList, refetch } = useQuery(['orderList', page, filterName], () => getOrder(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (orderList) {
         setTableData(orderList.data);
         setRowsPerPage(orderList?.metadata.length != 0 ? orderList?.metadata[0].limit : 10);
      }
      if (orderList?.metadata.length != 0 && orderList?.metadata[0].hasMoreData == true) {
         getOrder(page + 1);
      }
      setLoding(false);
   }, [orderList])

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getOrder(page, filterName)
      refetch();
   };
   // async function getFoodCategory() {
   //    const response = await axiosPrivate.get(FOOD_ITEMS.getFoodCategory, { params: { page: 1 } })
   //    return response.data;
   // }
   // const { data: foodCategorys } = useQuery(['foodCategorys'], () => getFoodCategory(), { keepPreviousData: true, })
   // useEffect(() => {
   //    if (foodCategorys !== undefined) {
   //       setFoodCategory(foodCategorys[0].data)
   //    }
   // }, [foodCategorys])

   // async function getFoodMenu() {
   //    const response = await axiosPrivate.get(FOOD_ITEMS.getFoodMenu, { params: { page: 1 } })
   //    return response.data;
   // }
   // const { data: foodMenu } = useQuery(['foodMenu'], () => getFoodMenu(), { keepPreviousData: true, })
   // useEffect(() => {
   //    if (foodMenu !== undefined) {
   //       setFoodMenuData(foodMenu[0].data)
   //    }
   // }, [foodMenu])

   const completedSchema = Yup.object().shape({
      name: Yup.string()
         .min(2, "name can set of between 2 and 50 characters!")
         .max(50, "name can set of between 2 and 50 characters!")
         .required("name is required"),
      price: Yup.string().required('price is required'),
      description: Yup.string().required('description is required'),
      order_number: Yup.string().required('order number is required')
   });

   const formik = useFormik({
      initialValues: {
         food_category_id: "",
         food_menu_id: "",
         name: "",
         price: "",
         description: "",
         order_number: "",
         image: ""
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
         const informationObj = {
            name: values.name,
            price: values.price,
            description: values.description,
            order_number: values.order_number,
            image: imageName
         };
         if (food_category_id) {
            informationObj.food_category_id = food_category_id;
         }
         if (food_menu_id) {
            informationObj.food_menu_id = food_menu_id;
         }
         if (Id == "") {
            await foodAdd(informationObj);
         } else {
            await foodItemUpdate(informationObj);
         }
         resetForm();
         setSubmitting(false);
      },
   });

   const { mutateAsync: foodAdd } = useMutation(
      async (data) => {
         return await axiosPrivate.post(FOOD_ITEMS.addFood, data)
      },
      {
         onSuccess: ({ data }) => {
            enqueueSnackbar("Item add successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
            refetch();
         },
         onError: (error) => {
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               } else if (key === "food_category_id") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "food_menu_id") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "price") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "order_number") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "description") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "image") {
                  setFieldError(key, errorData[key]);
               }
               else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   const { mutateAsync: foodItemUpdate } = useMutation(
      async (data) => {
         return await axiosPrivate.put(FOOD_ITEMS.editFood + Id, data)
      },
      {
         onSuccess: ({ data }) => {
            refetch();
            enqueueSnackbar("Item update successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
         },
         onError: (error) => {
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });

      return stabilizedThis.map((el) => el[0]);
   }

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - categoryList?.metadata[0].total) : 0;

   const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

   const handleClose = () => {
      setOpen(false);
      setShowImage('');
   };

   const deleteOrder = async () => {
      const response = await axiosPrivate.delete(ORDERS.deleteOrder + deleteId)
      if (response.status == 200) {
         enqueueSnackbar("Order delete successfully", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      } else {
         enqueueSnackbar("something went wrong", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch();
      handleClose();
   };

   const handleOpenModalAdd = () => {
      setFieldValue('name', "")
      setFieldValue('price', "")
      setFieldValue('description', "")
      setFieldValue('order_number', "")
      setFieldValue('food_category_id', "")
      setFieldValue('food_menu_id', "")
      setShowImage('');
      setId('')
      setmodelTitle('Food Item Add')
      setDisable(false);
      setOpenModal(true);
   };

   const handleOpenModalUpdate = (row) => {
      setFoodCategoryId(row?.food_category_data?._id)
      setFoodMenuId(row?.food_menu_data?._id)
      setFieldValue("food_category_id", row?.food_category_data?._id)
      setFieldValue("food_menu_id", row?.food_menu_data?._id)
      setFieldValue('name', row.name)
      setFieldValue('price', row.price)
      setFieldValue('description', row.description)
      setFieldValue('order_number', row.order_number)
      setFieldValue('image', row.image)
      setShowImage(row.image)
      setId(row._id)
      setmodelTitle('Food Item Update')
      setDisable(true);
      setOpenModal(true);
   };

   const handleClickOpen = (categoryId, categoryType) => {
      setdeleteId(categoryId);
      setOpen(true);
   };

   const handleCloseModal = () => {
      setOpenModal(false);
   };

   const handleProfilePicOnChange = async (ev) => {
      if (ev.type.includes("image")) {
         let userImgSrc = URL.createObjectURL(ev);
         const formData = new FormData();
         formData.append('image', ev)
         setProfilePic(userImgSrc);
         // setImageDataStore(formData)
         const imageData = await axiosPrivate.post(FOOD_ITEMS.uploadImage, formData)
         setImageName(imageData?.data?.file_name)
         setFieldValue("image", imageData?.data?.file_name)
      }
   };

   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, setFieldTouched } = formik;

   const handleFoodCategoryOnChange = (event) => {
      setFoodCategoryId(event.target.value);
   };

   const handleFoodMenuOnChange = (event) => {
      setFoodMenuId(event.target.value);
   };

   const changeStatus = async (id) => {
      const response = await axiosPrivate.put(FOOD_ITEMS.changeFoodItemStatus + id)
      if (response?.data?.message) {
         enqueueSnackbar(response?.data?.message, {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch()
   }

   const handleViewDetail = (orderDetails) => {
      navigate(ORDER.general.orderDetails, { state: { orderDetails: orderDetails } });
   }

   return (
      <>
         {loding ? <LoadingScreen /> : <>
            <div className="dashboard_header mb-4">
               <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Orders</h4>
               <Paper component="form" className='dashboard_searchbox col-lg-4'>
                  <IconButton>
                     <SearchIcon />
                  </IconButton>
                  <InputBase
                     fullWidth
                     sx={{ flex: 1 }}
                     placeholder="search ..."
                     onChange={(e) => handleFilterByName(e)}
                     onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                  />
               </Paper>
            </div>
            <Dialog
               fullScreen={fullScreen}
               open={open}
               onClose={handleClose}
               aria-labelledby="responsive-dialog-title"
            >
               <DialogTitle id="responsive-dialog-title" className='m-auto'>
                  {"are you sure you want to delete?"}
               </DialogTitle>
               <DialogContent>
               </DialogContent>
               <DialogActions className='m-auto'>
                  <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                     cancel
                  </Button>
                  <Button className="theme_button" variant="contained" onClick={() => deleteOrder()} autoFocus>
                     delete
                  </Button>
               </DialogActions>
            </Dialog>
            <Card>
               <TableContainer>
                  <Table>
                     <UserListHead
                        headLabel={TABLE_HEAD}
                        rowCount={orderList?.data?.length}
                        onRequestSort={handleRequestSort}
                     />
                     {filteredUsers?.length > 0 ?
                        <TableBody>
                           {filteredUsers.map((row) => {
                              return (
                                 <StyledTableRow key={row._id}>
                                    <TableCell component="th" scope="row">
                                       {row?.user_data?.firstname}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                       {row?.user_data?.email}
                                    </TableCell>
                                    <TableCell align="left"> {row?.order_number} </TableCell>
                                    <TableCell align="left"> {moment(row?.createdAt).format("DD MMM YYYY h:mm A")}</TableCell>
                                    <TableCell>
                                       <Stack direction="row" spacing={3}>
                                          {
                                             row.status == 0 ? <Chip variant="contained" className="app_status_chip pending" label="Pending" onClick={() => changeStatus(row._id)} /> : (row.status == 1 ? <Chip variant="contained" className="app_status_chip accepted" label="Completed" onClick={() => changeStatus(row._id)} /> : <Chip variant="contained" className="app_status_chip invalid" label="Reject" onClick={() => changeStatus(row._id)} />)
                                          }
                                       </Stack>
                                    </TableCell>
                                    <TableCell>
                                       <Stack direction="row" spacing={3}>
                                          <Button title="Order Details" variant="text" className="user_list_row_btn" onClick={(e) => handleViewDetail(row)} ><VisibilityIcon /></Button>
                                          {permissionsData?.order?.substring(2, 3) == "1" ?
                                             <Button title="Order Delete" variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id, "main")} ><BinIcon /></Button>
                                             : ""}
                                       </Stack>
                                    </TableCell>
                                 </StyledTableRow>
                              )
                           })}
                        </TableBody>
                        :
                        <TableBody>
                           <TableRow>
                              <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                 <span className="app_text_16_semibold">No Data Found</span>
                              </TableCell>
                           </TableRow>
                        </TableBody>}
                  </Table>
               </TableContainer>
               <TablePagination
                  component="div"
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  count={orderList?.metadata.length != 0 ? orderList?.metadata[0].total : 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
               />
            </Card>
            <Modal
               open={openModal}
               onClose={handleCloseModal}
               aria-labelledby="child-modal-title"
               aria-describedby="child-modal-description"
            >
               <Box className="modal_card modal_lg custom_form_mui">
                  <div className="modal_card_header">
                     <div className="left_part">
                        <h4>{modelTitle}</h4>
                     </div>
                     <div className="right_part">
                        <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                           <CloseIcon style={{ color: '#fff' }} />
                        </Button>
                     </div>
                  </div>
                  <div className="modal_card_body">
                     <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                           <div className="row">
                              <div className="col-lg-6 ">
                                 <div className="form-group mb-3">
                                    <TextField label='Name' name='name' autoComplete='off' fullWidth variant='outlined'
                                       {...getFieldProps("name")}
                                       error={Boolean(touched.name && errors.name)}
                                       helperText={touched.name && errors.name}
                                    />
                                 </div>
                              </div>
                              <div className="col-lg-6">
                                 <div className="form-group mb-4">
                                    <TextField label='Price' name='price' type='text' autoComplete='off' fullWidth variant='outlined'
                                       {...getFieldProps("price")}
                                       error={Boolean(touched.price && errors.price)}
                                       helperText={touched.price && errors.price}
                                    />
                                 </div>
                              </div>
                              <div className="col-lg-6">
                                 <div className="form-group mb-4">
                                    <TextField label='Description' name='description' autoComplete='off' fullWidth variant='outlined'
                                       {...getFieldProps("description")}
                                       error={Boolean(touched.description && errors.description)}
                                       helperText={touched.description && errors.description}
                                    />
                                 </div>
                              </div>
                              <div className="col-lg-6">
                                 <div className="form-group mb-4">
                                    <TextField
                                       label='Order Number'
                                       name='order_number'
                                       type="text" autoComplete='off' fullWidth variant='outlined'
                                       {...getFieldProps("order_number")}
                                       error={Boolean(touched.order_number && errors.order_number)}
                                       helperText={touched.order_number && errors.order_number}
                                    />
                                 </div>
                              </div>
                           </div>
                           <div className="col-lg-6">
                              <div className="img_preview_circle">
                                 <img src={profilePic == '' ? process.env.REACT_APP_IMAGE_URL + 'foodItem/' + showImage : profilePic} alt="profile" />
                              </div>
                              <Button
                                 className="my-4 text-white app_bg_primary app_text_16"
                                 variant="contained"
                                 component="label"
                                 style={{ "borderRadius": 5 }}
                              >
                                 {Id ? 'Change image' : 'Select Image'}
                                 <input
                                    hidden
                                    accept="image/*"
                                    onChange={(event) => {
                                       const files = event.target.files[0];
                                       handleProfilePicOnChange(files);
                                    }}
                                    type="file"
                                 />
                              </Button>
                              <FormHelperText error>
                                 {errors.image}
                              </FormHelperText>
                           </div>
                           <div className="col">
                              <div className="col-md-8 m-auto">
                                 <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                                 >
                                    submit
                                 </Button>
                              </div>
                           </div>
                        </Form>
                     </FormikProvider>
                  </div>
                  <div className="modal_card_footer"></div>
               </Box>
            </Modal>
         </>
         }
      </>
   )
}

export default Order